import { XAxis, YAxis, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts'
import { Card } from './Card'

export const Employee9BoxPerformanceTrend = ({ data, isLoading, filter, onSubmitFilter }) => {
    return (
        <Card
            isLoading={isLoading}
            title='9-Box Performance Trend'
            filterTitle='Filter Employee 9 Box Performance Trend'
            initFilter={filter}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='relative w-full h-full'>
                <ResponsiveContainer width='100%' height={310}>
                    <AreaChart data={data}>
                        <defs>
                            <linearGradient id='colorTrend' x1='0' y1='0' x2='0' y2='1'>
                                <stop offset='5%' stopColor='#0f4c5c' stopOpacity={0.3} />
                                <stop offset='95%' stopColor='#0f4c5c' stopOpacity={0} />
                            </linearGradient>
                        </defs>

                        <XAxis dataKey='year' />
                        <YAxis hide />
                        <Tooltip
                            formatter={(value, name, props) => {
                                const count = props?.payload?.count
                                return `${value}% (${count})`
                            }}
                        />

                        <Area
                            type='monotone'
                            name='Percentage'
                            dataKey='percentage'
                            stroke='#0f4c5c'
                            strokeWidth={3}
                            fill='url(#colorTrend)'
                            dot={false}
                        />
                    </AreaChart>
                </ResponsiveContainer>

                {!data?.length && (
                    <div className='absolute inset-0 flex items-center justify-center font-semibold text-neutral-60'>
                        Data Not Available
                    </div>
                )}

                <div className='flex gap-1.5 items-center w-fit px-2 py-1 mx-auto bg-neutral-10 border border-neutral-20 rounded-lg'>
                    <div className='w-3 h-3 bg-green-50 rounded-full'></div>
                    <span className='text-primary-50 font-semibold'>{filter?.nine_box_label} Trend</span>
                </div>
            </div>
        </Card>
    )
}
